import React from "react";
import { useTranslation } from "react-i18next";

const PromotionSkeletons = ({ count = 6 }) => {
  const { t } = useTranslation("common");

  return (
    <div
      className="ordering-discounts-skeletons border-border bg-background rounded-xl border p-4"
      role="status"
      aria-busy="true"
    >
      <span className="sr-only">{t("states.loading")}</span>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="border-border bg-background animate-pulse rounded-xl border p-4"
          >
            <div className="bg-card mb-4 h-32 w-full rounded-lg" />

            <div className="space-y-3">
              {/* Title & badge row */}
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 space-y-2">
                  <div className="bg-card h-4 w-3/4 rounded" />
                  <div className="bg-card h-3 w-1/2 rounded" />
                </div>
                <div className="bg-card h-5 w-16 rounded-full" />
              </div>

              {/* Description */}
              <div className="bg-card h-3 w-full rounded" />

              {/* Code & Discount row */}
              <div className="border-border bg-background/60 mt-2 flex items-center justify-between gap-4 rounded-lg border p-3">
                <div className="w-1/2 space-y-1">
                  <div className="bg-card h-2 w-10 rounded" />
                  <div className="bg-card h-3 w-20 rounded" />
                </div>
                <div className="w-1/2 space-y-1 text-right">
                  <div className="bg-card ml-auto h-2 w-14 rounded" />
                  <div className="bg-card ml-auto h-3 w-16 rounded" />
                </div>
              </div>

              {/* Footer actions */}
              <div className="border-border mt-2 flex items-center justify-between border-t pt-4">
                <div className="flex items-center gap-3">
                  <div className="bg-card h-3 w-16 rounded" />
                  <div className="bg-card h-5 w-10 rounded-full" />
                </div>
                <div className="flex items-center gap-2">
                  <div className="bg-card h-7 w-7 rounded-lg" />
                  <div className="bg-card h-7 w-7 rounded-lg" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PromotionSkeletons;
